// Google Places API Configuration
export const GOOGLE_PLACES_CONFIG = {
  // You'll need to get these from Google Cloud Console
  API_KEY: process.env.REACT_APP_GOOGLE_PLACES_API_KEY || 'YOUR_API_KEY_HERE',
  
  // Your clinic's Google Place ID
  // To find this: https://developers.google.com/maps/documentation/places/web-service/place-id
  PLACE_ID: process.env.REACT_APP_GOOGLE_PLACE_ID || 'YOUR_PLACE_ID_HERE',
  
  // API endpoints
  PLACES_API_BASE: 'https://maps.googleapis.com/maps/api/place',
  
  // Number of reviews to fetch
  MAX_REVIEWS: 10,
  
  // Cache duration in milliseconds (5 minutes)
  CACHE_DURATION: 5 * 60 * 1000,
};

// Helper function to get initials from name
export const getInitials = (name) => {
  if (!name) return 'NA';
  return name
    .split(' ')
    .map(word => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

// Helper function to format date
export const formatDate = (timestamp) => {
  if (!timestamp) return '';
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Helper function to get star rating display
export const getStarRating = (rating) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 !== 0;
  
  return {
    fullStars,
    hasHalfStar,
    emptyStars: 5 - fullStars - (hasHalfStar ? 1 : 0)
  };
};
